import { render, staticRenderFns } from "./ClienteServicosPrestados.vue?vue&type=template&id=512bd97c"
import script from "./ClienteServicosPrestados.vue?vue&type=script&lang=js"
export * from "./ClienteServicosPrestados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports